import { render, staticRenderFns } from "./NivelBaixo.vue?vue&type=template&id=a99887e0&scoped=true"
import script from "./NivelBaixo.vue?vue&type=script&lang=js"
export * from "./NivelBaixo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99887e0",
  null
  
)

export default component.exports